/*
 * @Description: 弹窗组件
 * @Author: zhongshanxian01
 * @Date: 2021-04-22 09:58:24
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2021-04-22 09:58:34
 */

import React, { useState, useEffect } from 'react';
// 在main.scss中引入
// import '@styles/components/win-box.scss';

export interface Props {
    customClass?: string;
    visible: boolean;
    handleClose?: CallableFunction;
    contentSlot?: React.ReactElement;
}
const WinBox = (props: Props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        props.handleClose && props.handleClose();
        toggleShow(false);
    };
    const toggleShow = (show: boolean) => {
        setShow(show);
    };

    useEffect(() => {
        toggleShow(props.visible);
    });
    return (
        <div
            className={`win_box ${props.customClass ? props.customClass : ''}`}
            style={{ display: show ? 'block' : 'none' }}
        >
            <div className="win-wrap">
                <a
                    className="close"
                    onClick={() => {
                        handleClose();
                    }}
                ></a>
                <div className="win_content">{props.contentSlot}</div>
            </div>
        </div>
    );
};

export default WinBox;
